import { Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

interface InsiderStarProps {
  className?: string;
  size?: number;
}

/**
 * Twinkelend sterretje icoontje voor Insider gebruikers
 */
export function InsiderStar({ className, size = 14 }: InsiderStarProps) {
  return (
    <Sparkles 
      className={cn(
        "text-primary inline-block flex-shrink-0 twinkle-star",
        className
      )}
      size={size}
      aria-label="Insider"
    />
  );
}